import { AppSettings } from '../app.settings';
import { ThirdPartyScreenFiltersDataModel } from './third-party-screen-filters-data-model';

export class ThirdPartyScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: ThirdPartyScreenFiltersDataModel = new ThirdPartyScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: ThirdPartyScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
